/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewCouponCode
 */
export interface NewCouponCode {
    /**
     * 
     * @type {string}
     * @memberof NewCouponCode
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof NewCouponCode
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof NewCouponCode
     */
    code?: string;
    /**
     * 
     * @type {number}
     * @memberof NewCouponCode
     */
    maxUsage?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NewCouponCode
     */
    waiveProcessingFees?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewCouponCode
     */
    useFixedDiscount?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NewCouponCode
     */
    discountValue?: number;
    /**
     * 
     * @type {Date}
     * @memberof NewCouponCode
     */
    expirationDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof NewCouponCode
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NewCouponCode
     */
    courierId?: number;
}

/**
 * Check if a given object implements the NewCouponCode interface.
 */
export function instanceOfNewCouponCode(value: object): value is NewCouponCode {
    return true;
}

export function NewCouponCodeFromJSON(json: any): NewCouponCode {
    return NewCouponCodeFromJSONTyped(json, false);
}

export function NewCouponCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewCouponCode {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'code': json['code'] == null ? undefined : json['code'],
        'maxUsage': json['maxUsage'] == null ? undefined : json['maxUsage'],
        'waiveProcessingFees': json['waiveProcessingFees'] == null ? undefined : json['waiveProcessingFees'],
        'useFixedDiscount': json['useFixedDiscount'] == null ? undefined : json['useFixedDiscount'],
        'discountValue': json['discountValue'] == null ? undefined : json['discountValue'],
        'expirationDate': json['expirationDate'] == null ? undefined : (new Date(json['expirationDate'])),
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function NewCouponCodeToJSON(json: any): NewCouponCode {
    return NewCouponCodeToJSONTyped(json, false);
}

export function NewCouponCodeToJSONTyped(value?: NewCouponCode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'code': value['code'],
        'maxUsage': value['maxUsage'],
        'waiveProcessingFees': value['waiveProcessingFees'],
        'useFixedDiscount': value['useFixedDiscount'],
        'discountValue': value['discountValue'],
        'expirationDate': value['expirationDate'] == null ? undefined : ((value['expirationDate']).toISOString()),
        'isActive': value['isActive'],
        'courierId': value['courierId'],
    };
}

